<template>
  <div>
    <h2>サーベイ目標管理</h2>
    <v-dialog v-model="dialog">
      <v-card v-if="dialog">
        <v-card-title class="headline grey lighten-2" primary-title>クライアント情報の編集</v-card-title>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout row wrap>
              <v-flex md5>
                <v-text-field v-model="selectedItem.name" label="サーベイ名" required></v-text-field>
              </v-flex>
              <v-flex md4>
                <v-select
                  v-model="selectedItem.template_name"
                  :items="items"
                  item-text="text"
                  item-value="value"
                  label="サーベイテンプレート"
                  required
                />
              </v-flex>
              <v-flex md3>
                <v-checkbox v-model="selectedItem.has_target" label="目標設定を実施する" required />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md5>
                <date-input v-model="selectedItem.start_date" label="サーベイ開始日" />
              </v-flex>
              <v-flex md5>
                <date-input v-model="selectedItem.training_date" label="研修日" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog=false">キャンセル</v-btn>
          <v-btn @click="createItem">追加</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row　align-center>
      <v-flex md3>
        <v-btn @click="addItem">
          <v-icon>add</v-icon>追加
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table :headers="headers" :items="surveys" hide-actions class="elevation-1">
      <template slot="items" slot-scope="props">
        <tr @click="toManageSurvey(props.item)">
          <td class="text-xs-left">{{ getFormatDate(props.item.start_date) }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ hasTarget(props.item.has_target) }}</td>
          <td>
            <!-- <v-btn icon @click.stop="deleteItem(props.item)">
              <v-icon>delete</v-icon>
            </v-btn> -->
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import { unixtimeToFormattedDate, getMoment } from "@/utils/datetime.js";
import { mapMutations } from "vuex";
import { getNewSchedules, scheduleDictionary } from "@/utils/schedules.js";
import questions from "@/master/questions.json";
import autoMails from "@/master/auto_mails.json";
import DateInput from "@/components/common/simpleDateInput.vue";

const newItem = {
  has_target: true,
  name: "360度研修",
  question_sheet: { sections: [] },
  start_date: "",
  subjects: {},
  target_id: "",
  template_name: "manager",
  contacts: []
};


export default {
  components: {
    DateInput
  },
  data() {
    return {
      dbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys"),
      selectedItem: {},
      surveys: [],
      dialog: false,
      items: [],
      headers: [
        {
          text: "開始日",
          align: "left",
          sortable: false,
          value: "start"
        },
        {
          text: "サーベイ名",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "目標設定",
          align: "left",
          sortable: false,
          value: "has_target"
        },
        {
          text: "操作",
          align: "left",
          sortable: false
        }
      ],
      training_date: 0,
      start_date: 0
    };
  },
  created() {
    this.questions = questions;
  },
  mounted() {
    for (let question of Object.keys(this.questions)) {
      this.items.push({
        text: this.questions[question].japanese_template_name,
        value: question
      });
    }
    this.changeLoadingState(true);
    this.updateSurveys();
  },
  methods: {
    toManageSurvey(s) {
      this.$router.push({
        name: "manage_survey",
        params: { company_id: this.$route.params.company_id, survey_id: s.id }
      });
    },
    async updateSurveys() {
      this.surveys = [];
      const surveys =[]
      const docs = await this.dbRef.get();
      docs.forEach(doc => {
        surveys.push({ id: doc.id, ...doc.data() });
      });
      this.surveys = surveys.sort((a, b) => b.start_date - a.start_date)

      this.changeLoadingState(false);
    },
    addItem() {
      this.selectedItem = JSON.parse(
        JSON.stringify({ ...newItem, ...getNewSchedules() })
      );
      const moment = getMoment();
      this.selectedItem.start_date = moment()
        .startOf("day")
        .add(30, "day")
        .unix();
      this.selectedItem.training_date = this.selectedItem.start_date;
      this.dialog = true;
    },
    async createItem() {
      this.changeLoadingState(true);
      this.selectedItem.question_sheet = this.questions[
        this.selectedItem.template_name
      ];
      const schs = {};
      for (let sh of scheduleDictionary) {
        if (this.selectedItem.has_target) {
          schs[sh.key] =
            this.selectedItem[sh.base_date] + sh.diffrenceFromBaseDate;
        } else {
          if (sh.onlyHasTarget) {
            delete this.selectedItem[sh.key];
          } else {
            schs[sh.key] =
              this.selectedItem[sh.base_date] + sh.diffrenceFromBaseDate;
          }
        }
      }
      this.selectedItem = { ...this.selectedItem, ...schs };
      try {
        const survey = await this.dbRef.add(this.selectedItem);
        this.addAutoMails(survey.id);
        this.dialog = false;
        this.updateSurveys();
      } catch (e) {
        console.error(e);
        this.changeLoadingState(false);
      }
    },
    getFormatDate(ut) {
      return unixtimeToFormattedDate(ut);
    },
    hasTarget(hasTarget) {
      return hasTarget ? "実施する" : "実施しない";
    },
    async deleteItem(item) {
      try {
        await this.dbRef.doc(item.id).delete();
        this.updateSurveys();
      } catch (e) {
        console.log(e);
      }
    },
    addAutoMails(surveyId) {
      autoMails.forEach(am => {
        this.dbRef
          .doc(surveyId)
          .collection("auto_mails")
          .add(am)
          .catch(e => console.error(e));
      });
    },
    ...mapMutations("app", ["changeLoadingState"])
  }
};
</script>
<style lang="scss" scoped>
</style>